import React from 'react';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';

import { RepositoriesList } from './RepositoriesList';

export const RepositoriesModal = ({ selectedOrganization, isOpen, onClose }) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <ModalOverlay />
    <ModalContent width="22.5rem">
      <ModalBody backgroundColor="primary.400" borderRadius="inherit" paddingTop={4}>
        <RepositoriesList selectedOrganization={selectedOrganization} />
      </ModalBody>
    </ModalContent>
  </Modal>
);
